import React from "react";
import Sidebar from "../Layout/Sidebar";
import Body from "../Layout/Body";

const Home = () => {
    return(
        <div className="background ">
            <div className="sidebar-main">
                <Sidebar/>
            </div>
            <div className="body">
                <Body/>
            </div>
        </div>
    );
};
export default Home